module.exports = __webpack_public_path__ + "files/73b789e440314bcef81b060a19415dd6.svg";